module.exports = __webpack_public_path__ + "static/media/badge_center.0ced37d4.svg";